module.exports = __webpack_public_path__ + "static/Benefits-7273aaa50d04fe7f57859e30c9de9915.png";